import { Product_Inventory, Product_SkuSize } from '@proto/store/api/store/product';

export class SizeInfo {
  get stockRemind(): boolean {
    return !this.inventory?.num && !!this.inventory?.stockRemind;
  }

  constructor(
    public size: Product_SkuSize,
    public inventory: Product_Inventory | undefined
  ) {}
}
